import { Component, OnInit, Input } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { datetimesettings, deepCopy, isDateRangeValid } from '../../utils/utils';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import {
  BookingModel, BookingService, GetVehicleResult,
  FindCustomerResult, AgenciesService, GetAllAgenciesResult, VehiclesService, customerVehicle, recentBookingResult,CustomersService
} from 'src/app/Api_Module';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { bookingServices } from 'src/app/models/constants.model';
import { Globals } from '../../globals';

@Component({
  selector: 'crg-create-booking-modal',
  templateUrl: './create-booking-modal.component.html'
})
export class CreateBookingModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() vehicle?: GetVehicleResult;
  @Input() customer?: FindCustomerResult;
  @Input() bookingExisting?: BookingModel;
  booking: BookingModel;

  times: string[] = [];
  alert: any;
  loading: boolean;
  isAgent: boolean;
  isValidPromoCode: boolean;
  makebooking$: Observable<any>;
  checkout$: Observable<any>;

  dropDate: Date;
  collectionDate: Date;
  dropTime: number;
  collectionTime: number;

  agencies: GetAllAgenciesResult[] = [];
  cars: customerVehicle[] = [];
  updateMode: boolean;
  foragency: boolean;
  services: any[];
  selectedAgency: any;
  mindate: NgbDateStruct = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };

  constructor(public authService: AuthenticationService, private modalService: NgbModal, private bookingService: BookingService,
    private agenciesService: AgenciesService, private router: Router, private toastr: ToastrService, private vehicleService: VehiclesService, private globals: Globals
  ,private customerService: CustomersService) {

  }

  ngOnInit() {
    for (let t = 0; t < 24; t++) {
      this.times.push(t.toString());
    }
    this.services = bookingServices;

  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
    if (!!this.bookingExisting && this.bookingExisting.bookingId > 0) {
      this.booking = this.bookingExisting;
      this.collectionDate = new Date(this.booking.checkout);
      this.dropDate = new Date(this.booking.checkIn);
      this.collectionTime = this.collectionDate.getHours();
      this.dropTime = this.dropDate.getHours();
      this.updateMode = true;
      this.vehicleService.getcars(this.bookingExisting.vehicleId).subscribe(resp => {
        this.cars = resp;
      });
    } else {
      this.Init();
      this.updateMode = false;
    }

    if (this.authService.isAgent()) {
      this.booking.paymentType = 'agency';
      this.booking.agencyId = this.authService.getAgencyId();
    }

    this.agenciesService.getAgencies().subscribe((resp) => {
      this.agencies = [...resp];
    });
  }

  private Init() {
    this.booking = { agencyId: null , reference: null};
    this.collectionDate = new Date();
    this.dropDate = new Date();
    this.collectionTime = this.collectionDate.getHours();
    this.dropTime = this.dropDate.getHours();
    this.collectionDate.setDate(this.collectionDate.getDate() + 1);
    this.booking.paymentType = null;
    this.booking.service = '';
    if (this.authService.isClient()) {
      this.customerService.getVehicles(this.authService.getCustomerId()).subscribe(resp => {
        this.cars = resp;
        this.booking.vehicleId = resp[0].id;
      });
    } else {
      this.customerService.getVehicles(this.customer.id).subscribe(resp => {
        this.cars = resp;
        this.booking.vehicleId = resp[0].id;
      });
    }
    if (this.vehicle) {
      this.booking.vehicleId = this.vehicle.id;
    }
  }

  close(alert: any) {
    this.alert = null;
  }

  private dateToString(date: Date, hours?: number): string {
    const day = date.getDate();
    const monthIndex = date.getMonth() + 1;
    const year = date.getFullYear();
    if (!hours) {
      hours = date.getHours();
    }
    const munites = date.getMinutes();
    const datestr = `${year}-${monthIndex < 10 ? '0' + monthIndex : monthIndex}-${day < 10 ? '0' + day : day}`
      + `T${hours < 10 ? '0' + hours : hours}:${munites < 10 ? '0' + munites : munites}`;
    console.log(datestr);
    return datestr;
  }

  createBooking() {
    if (!isDateRangeValid(this.dropDate, this.dropTime, this.collectionDate, this.collectionTime)) {
      this.toastr.warning('Invalid date range, Drop-Time should be before Pick-Up Time');
      return;
    }

    this.alert = null;
    this.loading = true;
    this.booking.checkIn = this.dropDate;
    this.booking.checkout = this.collectionDate;
    this.booking.checkIn.setHours(0, (this.dropTime * 60), 0, 0);
    this.booking.checkIn = this.convertUTCDateToLocalDate(this.booking.checkIn);
    this.booking.checkout.setHours(0, (this.collectionTime * 60), 0, 0);
    this.booking.checkout = this.convertUTCDateToLocalDate(this.booking.checkout);
   // this.booking.vehicleId = 4700// this.vehicle.id; //TODO?? where this is supposed to come from?
    this.booking.agencyId = this.booking.paymentType === 'agency' ? this.booking.agencyId : null;
    console.log('book data' + JSON.stringify(this.booking));

    this.bookingService.createBooking(this.booking).subscribe(resp => {
      this.loading = false;
      console.log(this.booking);
      // const booking: Booking = resp.body;
      this.toastr.success('Booking Captured, reference number : ' + resp.reference);
        if (this.authService.isStaff()) {
            let navigationExtras: NavigationExtras = {
                queryParams: { 'query': resp.reference },
                fragment: 'anchor'
            };
            this.router.navigate(['search/bookings'],navigationExtras);
        } else {
            //Change detection force immutable data types...
            this.getCustomerBookings();
        }
        //this.toastr.success('Booking Captured, reference number : ' + resp.reference);
        this.modalService.dismissAll();

    },
      error => {
        if (error['status'] === 404) {
          this.toastr.warning(error['message']);
        }
        this.loading = false;
        this.toastr.error('Something went wrong please try again later. ' + JSON.stringify(error.error) + '`');
        console.log('error:' + JSON.stringify(error));
      });
  }
  getCustomerBookings() {
    if (!this.authService.isClient()) return;
    this.loading = true;
    this.customerService.getBookings(this.authService.getCustomerId()).subscribe(resp => {
        this.loading = false;
        this.globals.recentBookings = resp;
      },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
  }

  convertUTCDateToLocalDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  updateBooking() {

    if (!isDateRangeValid(this.dropDate, this.dropTime, this.collectionDate, this.collectionTime)) {
      this.toastr.warning('Invalid date range, Drop-Time should be before Pick-Up Time');
      return;
    }
    this.alert = null;
    this.loading = true;
    this.booking.checkIn = this.dropDate;
    this.booking.checkout = this.collectionDate;
    this.booking.checkIn.setHours(0, (this.dropTime * 60), 0, 0);
    this.booking.checkIn = this.convertUTCDateToLocalDate(this.booking.checkIn);
    this.booking.checkout.setHours(0, (this.collectionTime * 60), 0, 0);
    this.booking.checkout = this.convertUTCDateToLocalDate(this.booking.checkout);
    console.log('book data' + JSON.stringify(this.booking));

    this.bookingService.updateBooking(this.booking).subscribe(resp => {
      this.loading = false;
      this.bookingService.getAction(this.booking.reference).subscribe(resp => {
        this.booking = resp[0];
      });
      this.toastr.success('Booking Updated!');
      this.modalService.dismissAll();
      this.getCustomerBookings();
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later. ' + JSON.stringify(error.error) + '`');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  getMinDateForCollection(): NgbDateStruct {
    const dropOffDate = !!this.dropDate ? new Date(this.dropDate.getTime()) : new Date();
    this.dropDate.setMinutes(0, 0, 0);
    this.collectionDate.setMinutes(0, 0, 0);
    if (this.collectionDate.getTime() < dropOffDate.getTime()) {
      this.collectionDate = dropOffDate;
    }
    return { year: dropOffDate.getFullYear(), month: dropOffDate.getMonth() + 1, day: dropOffDate.getDate() };
  }

  getTimesForCollection(): string[] {
    const times = [... this.times];
    // const dropOffDate = !!this.dropDate ? new Date(this.dropDate.getTime()) : new Date();
    // if (this.dropDate.getTime() ===  this.collectionDate.getTime()) {
    //   times.splice(0, this.dropDate.getHours() + 1);
    // }
    return times;
  }

  applyPromoCode() {
    this.isValidPromoCode = false;

    this.bookingService.checkCode(this.booking.promoCode).subscribe(resp => {
      this.loading = false;
      this.toastr.success('Promotion Code Valid');
      this.isValidPromoCode = true;
    },
      error => {
        if (error['status'] === 404) {
          this.toastr.warning(error['message']);
        }
        this.loading = false;
        this.toastr.error('Something went wrong please try again later. ');
        console.log('error:' + JSON.stringify(error));
      });

  }

  getAgency(id: number) {
    if (!!id) {
      return this.agencies.find((agency) => {
        return (+agency.id === +id);
      });
    }
  }

}
